import React, { useEffect, useState } from "react";
import { api, INTEREST_LABELS, API } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Search, Download } from "lucide-react";

export default function AdminSubscribers() {
  const [q, setQ] = useState("");
  const [interest, setInterest] = useState("all");
  const [data, setData] = useState({ subscribers: [], count: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/admin/subscribers", { params: { q, interest } })
      .then((r) => setData(r.data))
      .finally(() => setLoading(false));
  }, [q, interest]);

  const exportCsv = async () => {
    const token = localStorage.getItem("gb_admin_token");
    const res = await fetch(`${API}/admin/subscribers/export`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "growbag-feliratkozok.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <p className="section-label">Feliratkozók</p>
          <h1 className="text-2xl sm:text-3xl font-bold text-[#201B18] mt-1">Lista · {data.count}</h1>
        </div>
        <button onClick={exportCsv} data-testid="admin-export-csv-button" className="btn-secondary self-start">
          <Download className="h-4 w-4" /> CSV export
        </button>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#8C8075]" />
          <Input placeholder="Keresés név, email, kupon..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-subscribers-search" className="pl-9" />
        </div>
        <Select value={interest} onValueChange={setInterest}>
          <SelectTrigger data-testid="admin-subscribers-filter-interest" className="w-full sm:w-56">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Minden érdeklődés</SelectItem>
            {Object.entries(INTEREST_LABELS).map(([k, v]) => (
              <SelectItem key={k} value={k}>{v}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="rounded-2xl bg-white border border-[#2C221E]/10 overflow-hidden" data-testid="admin-subscribers-table">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Név</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Telefon</TableHead>
                <TableHead>Érdeklődés</TableHead>
                <TableHead>Forrás</TableHead>
                <TableHead>Marketing</TableHead>
                <TableHead>Kupon</TableHead>
                <TableHead>Dátum</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={8} className="text-center text-[#8C8075] py-10">Betöltés...</TableCell></TableRow>
              ) : data.subscribers.length === 0 ? (
                <TableRow><TableCell colSpan={8} className="text-center text-[#8C8075] py-10">Még nincs adat.</TableCell></TableRow>
              ) : (
                data.subscribers.map((s) => (
                  <TableRow key={s.id}>
                    <TableCell className="font-medium">{s.first_name}</TableCell>
                    <TableCell className="text-[#5C524A]">{s.email}</TableCell>
                    <TableCell className="text-[#5C524A]">{s.phone || "–"}</TableCell>
                    <TableCell className="text-[#5C524A]">{INTEREST_LABELS[s.interest_level] || s.interest_level}</TableCell>
                    <TableCell className="font-mono-brand text-xs text-[#8C8075]">{s.utm_source || "direct"}</TableCell>
                    <TableCell>
                      {s.marketing_consent ? <Badge className="bg-[#EAF0EC] text-[#3B5843] border-[#4A6B53]/30">igen</Badge> : <Badge variant="outline">nem</Badge>}
                    </TableCell>
                    <TableCell className="font-mono-brand text-xs">{s.coupon_code}</TableCell>
                    <TableCell className="text-xs text-[#8C8075]">{new Date(s.created_at).toLocaleDateString("hu-HU")}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
